import { useSelector } from "react-redux";

import { formSelectors } from "store/selectors";
import { setRules as storeRules } from "store/actions/form";
import { mapRule } from "containers/Rules/List/ConditionBuilder/utils";

export const useFormRules = () => {
    const { rules } = useSelector(formSelectors.content);
    const mappedRules = (rules ?? []).map((rule) => {
        if (!rule.condition || rule.mapped) {
            //TODO: Rule is not migrated, build condition??
            return rule;
        }

        return mapRule(rule);
    });

    return [mappedRules, storeRules];
};

export default useFormRules;
